import { render } from "./cmp-reso24.vue?vue&type=template&id=541bfeea&ts=true"
import script from "./cmp-reso24.ts?vue&type=script&lang=ts"
export * from "./cmp-reso24.ts?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./cmp-reso24.scss?vue&type=style&index=0&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/home/luca/comperioprojects/selfbox_frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__